import React from "react";

function About() {
    return(
        <div className="animate-in fade-in-5 slide-in-from-bottom-5 duration-1000">
            <h1 className="font-body text-lg sm:text-xl md:text-2xl lg:text-2xl text-white font-thin">
            As a lover of math and computer science, my dream is to improve society through algorithms and
            computational innovation. I'm interested in software development, machine learning, and AI.
            </h1>
            <br />
            <h1 className="font-body text-lg sm:text-xl md:text-2xl lg:text-2xl text-white font-thin">
            Outside of tech, I'm an avid language learner. I'm fluent in English, Mandarin, and French —
            I am currently working on mastering Spanish. One of my life goals is to become a polyglot and be
            able to communicate with people all over the world.
            </h1>
            <br />
            <h1 className="font-body text-lg sm:text-xl md:text-2xl lg:text-2xl text-white font-thin">
            In my spare time, I enjoy listening to music, going to the gym, and kicking back to classic mobster films.
            </h1>
        </div>
    );
}

export default About;
